import { formatDuration, intervalToDuration, isValid } from 'date-fns'

/**
 * Formats the span between an event's start and end for read-only display —
 * e.g. "1 day 2 hours 30 minutes".
 *
 * Returns `null` when either side is missing or unparseable, or when the range
 * isn't positive (open end, or an end before the start that the form is about
 * to flag anyway), so callers render their own placeholder instead of a
 * misleading "0 minutes".
 */
export const formatEventDuration = (start?: string | Date | null, end?: string | Date | null) => {
  if (!start || !end) {
    return null
  }

  const startDate = new Date(start)
  const endDate = new Date(end)

  if (!isValid(startDate) || !isValid(endDate) || endDate <= startDate) {
    return null
  }

  return formatDuration(intervalToDuration({ start: startDate, end: endDate }))
}
